var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLixeira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.847857 4.42105H9.15143L8.655 12.6184C8.60714 13.3958 7.98357 14 7.22857 14H2.77143C2.01643 14 1.39286 13.3958 1.345 12.6184L0.847857 4.42105ZM10 2.21053V3.68421H0V2.21053H2.14286V1.47368C2.14286 0.659474 2.78214 0 3.57143 0H6.42857C7.21786 0 7.85714 0.659474 7.85714 1.47368V2.21053H10ZM3.57143 2.21053H6.42857V1.47368H3.57143V2.21053Z",
    fill: "#DF3C6D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixeira);
export default __webpack_public_path__ + "static/media/lixeira.114dc02e69ff44cb4f7138437e19413b.svg";
export { ForwardRef as ReactComponent };